var $84HHw$react = require("react");
var $84HHw$reactjsxruntime = require("react/jsx-runtime");
var $84HHw$muimaterialTooltip = require("@mui/material/Tooltip");
var $84HHw$styledcomponents = require("styled-components");
var $84HHw$muimaterialButton = require("@mui/material/Button");
var $84HHw$muimaterialCircularProgress = require("@mui/material/CircularProgress");
var $84HHw$lodashget = require("lodash.get");

"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Button", {
    enumerable: true,
    get: function get() {
        return $c06c31892548508b$exports.Button;
    }
});
var $c06c31892548508b$exports = {};
"use strict";
Object.defineProperty($c06c31892548508b$exports, "__esModule", {
    value: true
});
$c06c31892548508b$exports.Button = void 0;
var $ac782590520c5221$exports = {};
"use strict";
Object.defineProperty($ac782590520c5221$exports, "__esModule", {
    value: true
});
Object.defineProperty($ac782590520c5221$exports, "ArrowToolTip", {
    enumerable: true,
    get: function get() {
        return $ed5c8fe8c49aff37$exports.ArrowToolTip;
    }
});
var $ed5c8fe8c49aff37$exports = {};
"use strict";
Object.defineProperty($ed5c8fe8c49aff37$exports, "__esModule", {
    value: true
});
$ed5c8fe8c49aff37$exports.ArrowToolTip = void 0;

var $ed5c8fe8c49aff37$var$_react = $ed5c8fe8c49aff37$var$_interopRequireDefault($84HHw$react);

var $ed5c8fe8c49aff37$var$_Tooltip = $ed5c8fe8c49aff37$var$_interopRequireDefault($84HHw$muimaterialTooltip);

function $ed5c8fe8c49aff37$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $ed5c8fe8c49aff37$var$ArrowToolTip = $ed5c8fe8c49aff37$exports.ArrowToolTip = function ArrowToolTip(_ref) {
    var _ref$title = _ref.title, title = _ref$title === void 0 ? "" : _ref$title, _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className;
    return /*#__PURE__*/ (0, $84HHw$reactjsxruntime.jsx)($ed5c8fe8c49aff37$var$_Tooltip["default"], {
        title: title,
        className: className,
        arrow: true,
        children: children
    });
};





var $c06c31892548508b$var$_react = $c06c31892548508b$var$_interopRequireDefault($84HHw$react);
var $cac1573991102b6d$exports = {};
"use strict";
function $cac1573991102b6d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $cac1573991102b6d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $cac1573991102b6d$var$_typeof(o);
}
Object.defineProperty($cac1573991102b6d$exports, "__esModule", {
    value: true
});
$cac1573991102b6d$exports.sizeStyles = $cac1573991102b6d$exports.paddingStyles = $cac1573991102b6d$exports.defaultLabelStyle = $cac1573991102b6d$exports.colorStyles = $cac1573991102b6d$exports.circleProgressDisabledColorStyles = $cac1573991102b6d$exports.circleProgressColorStyles = $cac1573991102b6d$exports.buttonLoadingStyles = $cac1573991102b6d$exports.Wrapper = $cac1573991102b6d$exports.StyledCircularProgress = $cac1573991102b6d$exports.StyledButton = $cac1573991102b6d$exports.LabelWrapper = $cac1573991102b6d$exports.IconWrapper = void 0;

var $cac1573991102b6d$var$_react = $cac1573991102b6d$var$_interopRequireDefault($84HHw$react);

var $cac1573991102b6d$var$_styledComponents = $cac1573991102b6d$var$_interopRequireWildcard($84HHw$styledcomponents);
var $bebaee556f9a4756$exports = {};
"use strict";
Object.defineProperty($bebaee556f9a4756$exports, "__esModule", {
    value: true
});
$bebaee556f9a4756$exports.FONTS = void 0;
var $bebaee556f9a4756$var$FONTS = $bebaee556f9a4756$exports.FONTS = {
    displayXXL: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: "62px",
        lineHeight: "150%"
    },
    displayXL: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: "46px",
        lineHeight: "150%"
    },
    displayL: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: "34px",
        lineHeight: "150%"
    },
    displayM: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: "24px",
        lineHeight: "150%"
    },
    displayS: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: "18px",
        lineHeight: "180%"
    },
    displayXS: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: "14px",
        lineHeight: "180%"
    },
    displayXXS: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: "12px",
        lineHeight: "180%"
    },
    bodyL: {
        fontFamily: '"Inter", sans-serif',
        fontSize: "18px",
        lineHeight: "180%"
    },
    bodyM: {
        fontFamily: '"Inter", sans-serif',
        fontSize: "14px",
        lineHeight: "180%"
    },
    bodyS: {
        fontFamily: '"Inter", sans-serif',
        fontSize: "12px",
        lineHeight: "180%"
    },
    bodyXS: {
        fontFamily: '"Inter", sans-serif',
        fontSize: "10px",
        lineHeight: "180%"
    }
};


var $bb6a8a3022cc23ea$exports = {};
"use strict";
Object.defineProperty($bb6a8a3022cc23ea$exports, "__esModule", {
    value: true
});
$bb6a8a3022cc23ea$exports.viewports = $bb6a8a3022cc23ea$exports.typoSelector = $bb6a8a3022cc23ea$exports.typo = $bb6a8a3022cc23ea$exports.query = $bb6a8a3022cc23ea$exports.layer = $bb6a8a3022cc23ea$exports.gradient = $bb6a8a3022cc23ea$exports.fontWeight = $bb6a8a3022cc23ea$exports.colorSelector = $bb6a8a3022cc23ea$exports.color = $bb6a8a3022cc23ea$exports.breakpoint = $bb6a8a3022cc23ea$exports.boxShadowFocus = $bb6a8a3022cc23ea$exports.boxShadow = $bb6a8a3022cc23ea$exports.border = $bb6a8a3022cc23ea$exports.Theme = void 0;


var $bb6a8a3022cc23ea$var$_templateObject, $bb6a8a3022cc23ea$var$_templateObject2, $bb6a8a3022cc23ea$var$_templateObject3, $bb6a8a3022cc23ea$var$_templateObject4, $bb6a8a3022cc23ea$var$_templateObject5, $bb6a8a3022cc23ea$var$_templateObject6, $bb6a8a3022cc23ea$var$_templateObject7, $bb6a8a3022cc23ea$var$_templateObject8, $bb6a8a3022cc23ea$var$_templateObject9, $bb6a8a3022cc23ea$var$_templateObject10, $bb6a8a3022cc23ea$var$_templateObject11, $bb6a8a3022cc23ea$var$_templateObject12, $bb6a8a3022cc23ea$var$_templateObject13, $bb6a8a3022cc23ea$var$_templateObject14, $bb6a8a3022cc23ea$var$_templateObject15;
function $bb6a8a3022cc23ea$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
var $bb6a8a3022cc23ea$var$color = $bb6a8a3022cc23ea$exports.color = Object.freeze({
    p100: "#EEF7FF",
    p200: "#9AC7EF",
    p300: "#5AB1FF",
    p400: "#1D71F3",
    p500: "#1A4EC0",
    p600: "#112F86",
    a100: "#FFF6EC",
    a200: "#FFD3A5",
    a300: "#FF8932",
    a400: "#FF670A",
    a500: "#FF4D00",
    a600: "#A12A0B",
    b100: "#F0FDF1",
    b200: "#BAF8C3",
    b300: "#84F195",
    b400: "#47E160",
    b500: "#14B22E",
    b600: "#128325",
    c100: "#FDF1F2",
    c200: "#F7CAD4",
    c300: "#EE96A9",
    c400: "#DD5C75",
    c500: "#BB3853",
    c600: "#881D3F",
    d100: "#F6F4FE",
    d200: "#DFD9FB",
    d300: "#AB92F3",
    d400: "#7638DF",
    d500: "#491896",
    d600: "#30165F",
    g100: "#F6F6F8",
    g200: "#ECEEF2",
    g300: "#AEB8CB",
    g400: "#627495",
    g500: "#404B64",
    g600: "#262E41",
    e100: "#FFF1F1",
    e200: "#FFC7C5",
    e300: "#FF6A65",
    e400: "#ED2C25",
    e500: "#C7140E",
    e600: "#6D0400",
    white: "#FFFFFF",
    black: "#000000",
    facebook: "#4464a0",
    twitter: "#1da1f2",
    linkedin: "#0077b5"
});
var $bb6a8a3022cc23ea$var$colorSelector = $bb6a8a3022cc23ea$exports.colorSelector = function colorSelector(colorKey) {
    return function(props) {
        return props.theme.color[colorKey.toLowerCase()];
    };
};
var $bb6a8a3022cc23ea$var$typo = $bb6a8a3022cc23ea$exports.typo = Object.freeze(Object.keys($bebaee556f9a4756$exports.FONTS).reduce(function(acc, key) {
    acc[key] = (0, $84HHw$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject || ($bb6a8a3022cc23ea$var$_templateObject = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n      font-size: ",
        ";\n      font-family: ",
        ";\n      line-height: ",
        ";\n    "
    ])), $bebaee556f9a4756$exports.FONTS[key].fontSize, $bebaee556f9a4756$exports.FONTS[key].fontFamily, $bebaee556f9a4756$exports.FONTS[key].lineHeight);
    return acc;
}, {}));
var $bb6a8a3022cc23ea$var$typoSelector = $bb6a8a3022cc23ea$exports.typoSelector = function typoSelector(typoKey) {
    return function(props) {
        return props.theme.typo[typoKey];
    };
};
var $bb6a8a3022cc23ea$var$fontWeight = $bb6a8a3022cc23ea$exports.fontWeight = Object.freeze({
    light: (0, $84HHw$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject2 || ($bb6a8a3022cc23ea$var$_templateObject2 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    font-weight: 300;\n  "
    ]))),
    regular: (0, $84HHw$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject3 || ($bb6a8a3022cc23ea$var$_templateObject3 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    font-weight: 400;\n  "
    ]))),
    medium: (0, $84HHw$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject4 || ($bb6a8a3022cc23ea$var$_templateObject4 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    font-weight: 600;\n  "
    ]))),
    bold: (0, $84HHw$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject5 || ($bb6a8a3022cc23ea$var$_templateObject5 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    font-weight: 700;\n  "
    ])))
});
var $bb6a8a3022cc23ea$var$boxShadowFocus = $bb6a8a3022cc23ea$exports.boxShadowFocus = (0, $84HHw$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject6 || ($bb6a8a3022cc23ea$var$_templateObject6 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
    "\n  &:focus {\n    box-shadow: 0px 0px 10px ",
    ";\n  }\n"
])), $bb6a8a3022cc23ea$var$color.d100);
var $bb6a8a3022cc23ea$var$gradient = $bb6a8a3022cc23ea$exports.gradient = Object.freeze({
    lagoon: (0, $84HHw$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject7 || ($bb6a8a3022cc23ea$var$_templateObject7 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    background-image: linear-gradient(\n      87.41deg,\n      ",
        " 4.03%,\n      ",
        " 95.69%\n    );\n  "
    ])), $bb6a8a3022cc23ea$var$color.p500, $bb6a8a3022cc23ea$var$color.p600),
    wave: (0, $84HHw$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject8 || ($bb6a8a3022cc23ea$var$_templateObject8 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    background-image: linear-gradient(236.19deg, #133599 7.5%, #05164a 86.12%);\n  "
    ]))),
    nector: (0, $84HHw$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject9 || ($bb6a8a3022cc23ea$var$_templateObject9 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    background-image: linear-gradient(\n      84.4deg,\n      #e00051 6.75%,\n      ",
        " 97.26%\n    );\n  "
    ])), $bb6a8a3022cc23ea$var$color.a500)
});
var $bb6a8a3022cc23ea$var$boxShadow = $bb6a8a3022cc23ea$exports.boxShadow = Object.freeze({
    level1: (0, $84HHw$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject10 || ($bb6a8a3022cc23ea$var$_templateObject10 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.07);\n  "
    ]))),
    level2: (0, $84HHw$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject11 || ($bb6a8a3022cc23ea$var$_templateObject11 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.07);\n  "
    ]))),
    level3: (0, $84HHw$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject12 || ($bb6a8a3022cc23ea$var$_templateObject12 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.07);\n  "
    ]))),
    level4: (0, $84HHw$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject13 || ($bb6a8a3022cc23ea$var$_templateObject13 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    box-shadow: 0px 14px 28px rgba(0, 0, 0, 0.1);\n  "
    ]))),
    level5: (0, $84HHw$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject14 || ($bb6a8a3022cc23ea$var$_templateObject14 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    box-shadow: 0px 19px 38px rgba(0, 0, 0, 0.15);\n  "
    ]))),
    focus: (0, $84HHw$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject15 || ($bb6a8a3022cc23ea$var$_templateObject15 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    box-shadow: 0px 0px 10px ",
        ";\n  "
    ])), $bb6a8a3022cc23ea$var$color.d100)
});
var $bb6a8a3022cc23ea$var$border = $bb6a8a3022cc23ea$exports.border = Object.freeze({
    level1: "0.3px solid rgba(130, 130, 130, 0.5)"
});
var $bb6a8a3022cc23ea$var$layer = $bb6a8a3022cc23ea$exports.layer = Object.freeze({
    hidden: -1,
    select: 5,
    newQuoteButton: 45,
    navbar: 50,
    tooltip: 60,
    mobileSocialFooter: 70,
    popup: 90,
    modal: 100,
    slideOut: 1101,
    welcomeModal: 1301
});
var $bb6a8a3022cc23ea$var$viewports = $bb6a8a3022cc23ea$exports.viewports = {
    mobile: {
        width: 360,
        breakpoint: "sm"
    },
    tablet: {
        width: 768,
        breakpoint: "md"
    },
    desktop: {
        width: 1200,
        breakpoint: "lg"
    }
};
// https://material-ui.com/customization/default-theme/?expend-path=$.breakpoints.values
var $bb6a8a3022cc23ea$var$breakpoint = $bb6a8a3022cc23ea$exports.breakpoint = Object.freeze({
    // this prop is needed because webapp/imports/styledComponents/Grid/Column.js uses xs viewport
    xs: 0,
    sm: 0,
    md: $bb6a8a3022cc23ea$var$viewports.tablet.width,
    lg: $bb6a8a3022cc23ea$var$viewports.desktop.width
});
// https://getbootstrap.com/docs/4.3/layout/overview/
var $bb6a8a3022cc23ea$var$query = $bb6a8a3022cc23ea$exports.query = {
    min: {
        solve: function solve(width) {
            return "(min-width: ".concat(width, "px)");
        },
        tablet: "(min-width: ".concat($bb6a8a3022cc23ea$var$breakpoint.md, "px)")
    },
    max: {
        solve: function solve(width) {
            return "(max-width: ".concat(width - 0.02, "px)");
        },
        tablet: "(max-width: ".concat($bb6a8a3022cc23ea$var$breakpoint.lg - 0.02, "px)")
    },
    mobile: "(max-width: ".concat($bb6a8a3022cc23ea$var$breakpoint.md - 0.02, "px)"),
    tablet: "(min-width: ".concat($bb6a8a3022cc23ea$var$breakpoint.md, "px) and (max-width: ").concat($bb6a8a3022cc23ea$var$breakpoint.lg - 0.02, "px)"),
    desktop: "(min-width: ".concat($bb6a8a3022cc23ea$var$breakpoint.lg, "px)"),
    dpr2x: "(min-resolution: 2dppx), (min-resolution: 192dpi)",
    mobileDpr2x: "(max-width: ".concat($bb6a8a3022cc23ea$var$breakpoint.md - 0.02, "px) and (min-resolution: 2dppx), (max-width: ").concat($bb6a8a3022cc23ea$var$breakpoint.md - 0.02, "px) and (min-resolution: 192dpi)")
};
Object.keys($bb6a8a3022cc23ea$var$breakpoint).forEach(function(key) {
    $bb6a8a3022cc23ea$var$query.min[key] = $bb6a8a3022cc23ea$var$query.min.solve($bb6a8a3022cc23ea$var$breakpoint[key]);
    $bb6a8a3022cc23ea$var$query.max[key] = $bb6a8a3022cc23ea$var$query.max.solve($bb6a8a3022cc23ea$var$breakpoint[key]);
});
Object.freeze($bb6a8a3022cc23ea$var$query);
Object.freeze($bb6a8a3022cc23ea$var$query.min);
Object.freeze($bb6a8a3022cc23ea$var$query.max);
var $bb6a8a3022cc23ea$var$Theme = $bb6a8a3022cc23ea$exports.Theme = Object.freeze({
    color: $bb6a8a3022cc23ea$var$color,
    typo: $bb6a8a3022cc23ea$var$typo,
    border: $bb6a8a3022cc23ea$var$border,
    boxShadow: $bb6a8a3022cc23ea$var$boxShadow,
    boxShadowFocus: $bb6a8a3022cc23ea$var$boxShadowFocus,
    gradient: $bb6a8a3022cc23ea$var$gradient,
    layer: $bb6a8a3022cc23ea$var$layer,
    fontWeight: $bb6a8a3022cc23ea$var$fontWeight,
    query: $bb6a8a3022cc23ea$var$query
});


var $2d4500375a8ffcbf$exports = {};
"use strict";
Object.defineProperty($2d4500375a8ffcbf$exports, "__esModule", {
    value: true
});
$2d4500375a8ffcbf$exports.get = void 0;

var $2d4500375a8ffcbf$var$_lodash = $2d4500375a8ffcbf$var$_interopRequireDefault($84HHw$lodashget);
function $2d4500375a8ffcbf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $2d4500375a8ffcbf$var$get = $2d4500375a8ffcbf$exports.get = function get(object, path, defaultValue) {
    var lodashResult = (0, $2d4500375a8ffcbf$var$_lodash["default"])(object, path, defaultValue);
    if (lodashResult === null && defaultValue !== undefined) return defaultValue;
    return lodashResult;
};



var $cac1573991102b6d$var$_Button = $cac1573991102b6d$var$_interopRequireDefault($84HHw$muimaterialButton);

var $cac1573991102b6d$var$_CircularProgress = $cac1573991102b6d$var$_interopRequireDefault($84HHw$muimaterialCircularProgress);

var $cac1573991102b6d$var$_excluded = [
    "isLoading",
    "colorStyle",
    "size",
    "className",
    "disabledTooltipText",
    "isGhost"
], $cac1573991102b6d$var$_excluded2 = [
    "colorStyle",
    "disabled"
];
var $cac1573991102b6d$var$_templateObject, $cac1573991102b6d$var$_templateObject2, $cac1573991102b6d$var$_templateObject3, $cac1573991102b6d$var$_templateObject4, $cac1573991102b6d$var$_templateObject5, $cac1573991102b6d$var$_templateObject6, $cac1573991102b6d$var$_templateObject7, $cac1573991102b6d$var$_templateObject8, $cac1573991102b6d$var$_templateObject9, $cac1573991102b6d$var$_templateObject10, $cac1573991102b6d$var$_templateObject11, $cac1573991102b6d$var$_templateObject12, $cac1573991102b6d$var$_templateObject13, $cac1573991102b6d$var$_templateObject14, $cac1573991102b6d$var$_templateObject15, $cac1573991102b6d$var$_templateObject16, $cac1573991102b6d$var$_templateObject17, $cac1573991102b6d$var$_templateObject18, $cac1573991102b6d$var$_templateObject19, $cac1573991102b6d$var$_templateObject20, $cac1573991102b6d$var$_templateObject21, $cac1573991102b6d$var$_templateObject22;
function $cac1573991102b6d$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($cac1573991102b6d$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $cac1573991102b6d$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $cac1573991102b6d$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $cac1573991102b6d$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $cac1573991102b6d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $cac1573991102b6d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cac1573991102b6d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cac1573991102b6d$var$ownKeys(Object(t), !0).forEach(function(r) {
            $cac1573991102b6d$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cac1573991102b6d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $cac1573991102b6d$var$_defineProperty(e, r, t) {
    return (r = $cac1573991102b6d$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $cac1573991102b6d$var$_toPropertyKey(t) {
    var i = $cac1573991102b6d$var$_toPrimitive(t, "string");
    return "symbol" == $cac1573991102b6d$var$_typeof(i) ? i : i + "";
}
function $cac1573991102b6d$var$_toPrimitive(t, r) {
    if ("object" != $cac1573991102b6d$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $cac1573991102b6d$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $cac1573991102b6d$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $cac1573991102b6d$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $cac1573991102b6d$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $cac1573991102b6d$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
var $cac1573991102b6d$var$defaultLabelStyle = $cac1573991102b6d$exports.defaultLabelStyle = {
    textTransform: "uppercase"
};
/**
 * Based on Material-ui CircularProgress attributes
 */ var $cac1573991102b6d$var$buttonLoadingStyles = $cac1573991102b6d$exports.buttonLoadingStyles = {
    primary: {
        size: 18,
        thickness: 7
    },
    ghost: {
        size: 18,
        thickness: 7
    }
};
var $cac1573991102b6d$var$circleProgressDisabledColorStyles = $cac1573991102b6d$exports.circleProgressDisabledColorStyles = {
    primary: (0, $cac1573991102b6d$var$_styledComponents.css)($cac1573991102b6d$var$_templateObject || ($cac1573991102b6d$var$_templateObject = $cac1573991102b6d$var$_taggedTemplateLiteral([
        "\n    color: ",
        ";\n  "
    ])), function(props) {
        return props.theme.color.g400;
    }),
    secondary: (0, $cac1573991102b6d$var$_styledComponents.css)($cac1573991102b6d$var$_templateObject2 || ($cac1573991102b6d$var$_templateObject2 = $cac1573991102b6d$var$_taggedTemplateLiteral([
        "\n    color: ",
        ";\n  "
    ])), function(props) {
        return props.theme.color.g400;
    }),
    ghost: (0, $cac1573991102b6d$var$_styledComponents.css)($cac1573991102b6d$var$_templateObject3 || ($cac1573991102b6d$var$_templateObject3 = $cac1573991102b6d$var$_taggedTemplateLiteral([
        "\n    color: ",
        ";\n  "
    ])), function(props) {
        return props.theme.color.g400;
    })
};
var $cac1573991102b6d$var$circleProgressColorStyles = $cac1573991102b6d$exports.circleProgressColorStyles = {
    primary: (0, $cac1573991102b6d$var$_styledComponents.css)($cac1573991102b6d$var$_templateObject4 || ($cac1573991102b6d$var$_templateObject4 = $cac1573991102b6d$var$_taggedTemplateLiteral([
        "\n    color: ",
        ";\n  "
    ])), function(props) {
        return (0, $2d4500375a8ffcbf$exports.get)(props, "theme.overrides.button.color", (0, $bb6a8a3022cc23ea$exports.colorSelector)("white"));
    }),
    secondary: (0, $cac1573991102b6d$var$_styledComponents.css)($cac1573991102b6d$var$_templateObject5 || ($cac1573991102b6d$var$_templateObject5 = $cac1573991102b6d$var$_taggedTemplateLiteral([
        "\n    color: ",
        ";\n  "
    ])), function(props) {
        return (0, $2d4500375a8ffcbf$exports.get)(props, "theme.overrides.button.color", (0, $bb6a8a3022cc23ea$exports.colorSelector)("white"));
    }),
    ghost: (0, $cac1573991102b6d$var$_styledComponents.css)($cac1573991102b6d$var$_templateObject6 || ($cac1573991102b6d$var$_templateObject6 = $cac1573991102b6d$var$_taggedTemplateLiteral([
        "\n    color: ",
        ";\n  "
    ])), function(props) {
        return props.theme.color.p600;
    })
};
var $cac1573991102b6d$var$colorStyles = $cac1573991102b6d$exports.colorStyles = {
    primary: (0, $cac1573991102b6d$var$_styledComponents.css)($cac1573991102b6d$var$_templateObject7 || ($cac1573991102b6d$var$_templateObject7 = $cac1573991102b6d$var$_taggedTemplateLiteral([
        "\n    background-color: ",
        ";\n    color: ",
        ";\n    &:hover,\n    &:active,\n    &:focus,\n    &.loading {\n      background-color: ",
        ";\n    }\n    &:disabled {\n      color: ",
        ";\n      background-color: ",
        ";\n    }\n  "
    ])), function(props) {
        return props.theme.color.p500;
    }, function(props) {
        return (0, $2d4500375a8ffcbf$exports.get)(props, "theme.overrides.button.color", (0, $bb6a8a3022cc23ea$exports.colorSelector)("white"));
    }, function(props) {
        return props.theme.color.p600;
    }, function(props) {
        return props.theme.color.g400;
    }, function(props) {
        return props.theme.color.g300;
    }),
    secondary: (0, $cac1573991102b6d$var$_styledComponents.css)($cac1573991102b6d$var$_templateObject8 || ($cac1573991102b6d$var$_templateObject8 = $cac1573991102b6d$var$_taggedTemplateLiteral([
        "\n    color: ",
        ";\n    border: 2px solid ",
        ";\n    background-color: ",
        ";\n    &:hover,\n    &:active,\n    &.loading {\n      background-color: ",
        ";\n      color: ",
        ";\n      border-color: ",
        ";\n    }\n    &:disabled {\n      color: ",
        ";\n      background-color: ",
        ";\n      border-color: ",
        ";\n    }\n  "
    ])), function(props) {
        return (0, $2d4500375a8ffcbf$exports.get)(props, "theme.overrides.button.color", (0, $bb6a8a3022cc23ea$exports.colorSelector)("p500"));
    }, function(props) {
        return props.theme.color.p500;
    }, function(props) {
        return props.theme.color.white;
    }, function(props) {
        return props.theme.color.p600;
    }, function(props) {
        return (0, $2d4500375a8ffcbf$exports.get)(props, "theme.overrides.button.color", (0, $bb6a8a3022cc23ea$exports.colorSelector)("white"));
    }, function(props) {
        return props.theme.color.p600;
    }, function(props) {
        return props.theme.color.g400;
    }, function(props) {
        return props.theme.color.g300;
    }, function(props) {
        return props.theme.color.g300;
    }),
    ghost: (0, $cac1573991102b6d$var$_styledComponents.css)($cac1573991102b6d$var$_templateObject9 || ($cac1573991102b6d$var$_templateObject9 = $cac1573991102b6d$var$_taggedTemplateLiteral([
        "\n    color: ",
        ";\n    background-color: transparent;\n    &:hover,\n    &:active {\n      color: ",
        ";\n      background-color: transparent;\n    }\n    &:disabled {\n      color: ",
        ";\n    }\n    &.loading {\n      ",
        ";\n      -webkit-background-clip: text;\n      -webkit-text-fill-color: transparent;\n    }\n  "
    ])), function(props) {
        return props.theme.color.p500;
    }, function(props) {
        return props.theme.color.p600;
    }, function(props) {
        return props.theme.color.g400;
    }, function(props) {
        return props.theme.gradient.lagoon;
    })
};
var $cac1573991102b6d$var$sizeStyles = $cac1573991102b6d$exports.sizeStyles = {
    ghost: (0, $cac1573991102b6d$var$_styledComponents.css)($cac1573991102b6d$var$_templateObject10 || ($cac1573991102b6d$var$_templateObject10 = $cac1573991102b6d$var$_taggedTemplateLiteral([
        "\n    height: fit-content;\n    min-width: fit-content;\n    border-radius: 0;\n    font-size: ",
        ";\n    line-height: ",
        ";\n  "
    ])), $bebaee556f9a4756$exports.FONTS.bodyM.fontSize, $bebaee556f9a4756$exports.FONTS.bodyM.lineHeight),
    icon: (0, $cac1573991102b6d$var$_styledComponents.css)($cac1573991102b6d$var$_templateObject11 || ($cac1573991102b6d$var$_templateObject11 = $cac1573991102b6d$var$_taggedTemplateLiteral([
        "\n    height: 50px;\n    min-width: 50px;\n    border-radius: 25px;\n    font-size: ",
        ";\n    line-height: ",
        ";\n    padding: 8px;\n  "
    ])), $bebaee556f9a4756$exports.FONTS.bodyS.fontSize, $bebaee556f9a4756$exports.FONTS.bodyS.lineHeight),
    small: (0, $cac1573991102b6d$var$_styledComponents.css)($cac1573991102b6d$var$_templateObject12 || ($cac1573991102b6d$var$_templateObject12 = $cac1573991102b6d$var$_taggedTemplateLiteral([
        "\n    border-radius: ",
        "px;\n    font-size: ",
        ";\n    line-height: ",
        ";\n  "
    ])), function(props) {
        return (0, $2d4500375a8ffcbf$exports.get)(props, "theme.overrides.button.borderRadius", 3);
    }, $bebaee556f9a4756$exports.FONTS.bodyS.fontSize, $bebaee556f9a4756$exports.FONTS.bodyS.lineHeight),
    medium: (0, $cac1573991102b6d$var$_styledComponents.css)($cac1573991102b6d$var$_templateObject13 || ($cac1573991102b6d$var$_templateObject13 = $cac1573991102b6d$var$_taggedTemplateLiteral([
        "\n    border-radius: ",
        "px;\n    font-size: ",
        ";\n    line-height: ",
        ";\n  "
    ])), function(props) {
        return (0, $2d4500375a8ffcbf$exports.get)(props, "theme.overrides.button.borderRadius", 3);
    }, $bebaee556f9a4756$exports.FONTS.displayXS.fontSize, $bebaee556f9a4756$exports.FONTS.displayXS.lineHeight),
    large: (0, $cac1573991102b6d$var$_styledComponents.css)($cac1573991102b6d$var$_templateObject14 || ($cac1573991102b6d$var$_templateObject14 = $cac1573991102b6d$var$_taggedTemplateLiteral([
        "\n    border-radius: ",
        "px;\n    font-size: ",
        ";\n    line-height: ",
        ";\n  "
    ])), function(props) {
        return (0, $2d4500375a8ffcbf$exports.get)(props, "theme.overrides.button.borderRadius", 3);
    }, $bebaee556f9a4756$exports.FONTS.bodyL.fontSize, $bebaee556f9a4756$exports.FONTS.bodyM.lineHeight)
};
/*
  different padding because of border to secondary button type
*/ var $cac1573991102b6d$var$paddingStyles = $cac1573991102b6d$exports.paddingStyles = {
    primary: (0, $cac1573991102b6d$var$_styledComponents.css)($cac1573991102b6d$var$_templateObject15 || ($cac1573991102b6d$var$_templateObject15 = $cac1573991102b6d$var$_taggedTemplateLiteral([
        "\n    padding: 12px 16px;\n  "
    ]))),
    secondary: (0, $cac1573991102b6d$var$_styledComponents.css)($cac1573991102b6d$var$_templateObject16 || ($cac1573991102b6d$var$_templateObject16 = $cac1573991102b6d$var$_taggedTemplateLiteral([
        "\n    padding: 10px 16px;\n  "
    ]))),
    ghost: (0, $cac1573991102b6d$var$_styledComponents.css)($cac1573991102b6d$var$_templateObject17 || ($cac1573991102b6d$var$_templateObject17 = $cac1573991102b6d$var$_taggedTemplateLiteral([
        "\n    padding: 0;\n  "
    ])))
};
var $cac1573991102b6d$var$LabelWrapper = $cac1573991102b6d$exports.LabelWrapper = $cac1573991102b6d$var$_styledComponents["default"].span($cac1573991102b6d$var$_templateObject18 || ($cac1573991102b6d$var$_templateObject18 = $cac1573991102b6d$var$_taggedTemplateLiteral([
    "\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  white-space: nowrap;\n"
])));
var $cac1573991102b6d$var$IconWrapper = $cac1573991102b6d$exports.IconWrapper = $cac1573991102b6d$var$_styledComponents["default"].span($cac1573991102b6d$var$_templateObject19 || ($cac1573991102b6d$var$_templateObject19 = $cac1573991102b6d$var$_taggedTemplateLiteral([
    "\n  padding-left: ",
    "px;\n  display: flex;\n"
])), function(props) {
    return props.labelValue ? 8 : 0;
});
var $cac1573991102b6d$var$Wrapper = $cac1573991102b6d$exports.Wrapper = $cac1573991102b6d$var$_styledComponents["default"].div($cac1573991102b6d$var$_templateObject20 || ($cac1573991102b6d$var$_templateObject20 = $cac1573991102b6d$var$_taggedTemplateLiteral([
    "\n  display: inline-block;\n\n  ",
    "\n\n  ",
    "\n  \n    ",
    "\n"
])), function(props) {
    return props.disabled ? "cursor: no-drop;" : "";
}, function(props) {
    return props.fullWidth && "\n        width: 100%;\n  \n        > button {\n          width: 100%;\n        }\n      ";
}, function(props) {
    return props.fullWidthOnMobile && "\n        @media ".concat(props.theme.query.mobile, " {\n          width: 100%;\n  \n          > button {\n            width: 100%;\n          }\n        }\n      ");
});
// TODO: Clean button its complete mess
var $cac1573991102b6d$var$StyledButton = $cac1573991102b6d$exports.StyledButton = (0, $cac1573991102b6d$var$_styledComponents["default"])(function(_ref) {
    var isLoading = _ref.isLoading, colorStyle = _ref.colorStyle, size = _ref.size, className = _ref.className, disabledTooltipText = _ref.disabledTooltipText, isGhost = _ref.isGhost, other = $cac1573991102b6d$var$_objectWithoutProperties(_ref, $cac1573991102b6d$var$_excluded);
    return /*#__PURE__*/ (0, $84HHw$reactjsxruntime.jsx)($cac1573991102b6d$var$_Button["default"], $cac1573991102b6d$var$_objectSpread($cac1573991102b6d$var$_objectSpread({}, other), {}, {
        classes: {
            // NOTE: This is for prevent blinking by rerendering
            root: [
                isLoading ? "loading" : "root",
                className
            ].join(" ").trim(),
            label: "label",
            text: "text"
        }
    }));
})($cac1573991102b6d$var$_templateObject21 || ($cac1573991102b6d$var$_templateObject21 = $cac1573991102b6d$var$_taggedTemplateLiteral([
    "\n  display: flex;\n  cursor: pointer;\n  font-family: ",
    ";\n  letter-spacing: inherit;\n  ",
    ";\n  ",
    ";\n  ",
    ";\n  ",
    ";\n  transition: all 0.4s ease-in-out;\n\n  &:focus {\n    box-shadow: none;\n  }\n\n  & > span:first-child {\n    text-transform: ",
    ";\n    ",
    "\n  }\n"
])), $bebaee556f9a4756$exports.FONTS.displayXS.fontFamily, function(props) {
    return props.theme.fontWeight.medium;
}, function(props) {
    return $cac1573991102b6d$var$colorStyles[props.colorStyle];
}, function(props) {
    return $cac1573991102b6d$var$paddingStyles[props.colorStyle];
}, function(props) {
    return $cac1573991102b6d$var$sizeStyles[props.size];
}, function(props) {
    return props.isGhost ? "capitalize" : $cac1573991102b6d$var$defaultLabelStyle.textTransform;
}, function(props) {
    return props.isGhost && "text-decoration: underline;";
});
var $cac1573991102b6d$var$StyledCircularProgress = $cac1573991102b6d$exports.StyledCircularProgress = (0, $cac1573991102b6d$var$_styledComponents["default"])(function(_ref2) {
    var colorStyle = _ref2.colorStyle, disabled = _ref2.disabled, other = $cac1573991102b6d$var$_objectWithoutProperties(_ref2, $cac1573991102b6d$var$_excluded2);
    return /*#__PURE__*/ (0, $84HHw$reactjsxruntime.jsx)($cac1573991102b6d$var$_CircularProgress["default"], $cac1573991102b6d$var$_objectSpread({}, other));
})($cac1573991102b6d$var$_templateObject22 || ($cac1573991102b6d$var$_templateObject22 = $cac1573991102b6d$var$_taggedTemplateLiteral([
    "\n  &.MuiCircularProgress-root {\n    position: inherit;\n    ",
    ";\n  }\n"
])), function(props) {
    return props.disabled ? $cac1573991102b6d$var$circleProgressDisabledColorStyles[props.colorStyle] : $cac1573991102b6d$var$circleProgressColorStyles[props.colorStyle];
});


var $54a26cd9a2f0c50b$exports = {};
"use strict";
Object.defineProperty($54a26cd9a2f0c50b$exports, "__esModule", {
    value: true
});
$54a26cd9a2f0c50b$exports.renderLabel = $54a26cd9a2f0c50b$exports.renderIcon = $54a26cd9a2f0c50b$exports.getSize = $54a26cd9a2f0c50b$exports.getLoadingIcon = $54a26cd9a2f0c50b$exports.getLabelValue = void 0;

var $54a26cd9a2f0c50b$var$_react = $54a26cd9a2f0c50b$var$_interopRequireDefault($84HHw$react);


function $54a26cd9a2f0c50b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $54a26cd9a2f0c50b$var$getLoadingIcon = $54a26cd9a2f0c50b$exports.getLoadingIcon = function getLoadingIcon(loadingIcon, colorStyle, disabled) {
    var key = loadingIcon ? null : "circular-".concat(Date.now());
    var defaultStyle = $cac1573991102b6d$exports.buttonLoadingStyles.primary;
    var circularStyle = $cac1573991102b6d$exports.buttonLoadingStyles[colorStyle] || defaultStyle;
    return loadingIcon || /*#__PURE__*/ (0, $84HHw$reactjsxruntime.jsx)($cac1573991102b6d$exports.StyledCircularProgress, {
        id: key,
        size: circularStyle.size,
        disabled: disabled,
        colorStyle: colorStyle,
        thickness: circularStyle.thickness
    }, key);
};
var $54a26cd9a2f0c50b$var$getLabelValue = $54a26cd9a2f0c50b$exports.getLabelValue = function getLabelValue(props) {
    var children = props.children, label = props.label, loadingLabel = props.loadingLabel, isLoading = props.isLoading;
    var selectedLabel = children || label;
    return isLoading ? loadingLabel || selectedLabel : selectedLabel;
};
var $54a26cd9a2f0c50b$var$renderIcon = $54a26cd9a2f0c50b$exports.renderIcon = function renderIcon(props) {
    var _props$icon = props.icon, icon = _props$icon === void 0 ? null : _props$icon, _props$loadingIcon = props.loadingIcon, loadingIcon = _props$loadingIcon === void 0 ? null : _props$loadingIcon, _props$isLoading = props.isLoading, isLoading = _props$isLoading === void 0 ? false : _props$isLoading, _props$colorStyle = props.colorStyle, colorStyle = _props$colorStyle === void 0 ? "primary" : _props$colorStyle, disabled = props.disabled;
    var iconValue = isLoading ? $54a26cd9a2f0c50b$var$getLoadingIcon(loadingIcon, colorStyle, disabled) : icon;
    if (!iconValue) return null;
    var labelValue = $54a26cd9a2f0c50b$var$getLabelValue(props);
    return /*#__PURE__*/ (0, $84HHw$reactjsxruntime.jsx)($cac1573991102b6d$exports.IconWrapper, {
        labelValue: labelValue,
        children: iconValue
    });
};
var $54a26cd9a2f0c50b$var$renderLabel = $54a26cd9a2f0c50b$exports.renderLabel = function renderLabel(props) {
    var labelValue = $54a26cd9a2f0c50b$var$getLabelValue(props);
    if (!labelValue) return null;
    return /*#__PURE__*/ (0, $84HHw$reactjsxruntime.jsx)($cac1573991102b6d$exports.LabelWrapper, {
        children: labelValue
    });
};
var $54a26cd9a2f0c50b$var$getSize = $54a26cd9a2f0c50b$exports.getSize = function getSize(size, isGhost) {
    return !isGhost ? size : "ghost";
};



function $c06c31892548508b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $c06c31892548508b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c06c31892548508b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c06c31892548508b$var$_typeof(o);
}
function $c06c31892548508b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c06c31892548508b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c06c31892548508b$var$ownKeys(Object(t), !0).forEach(function(r) {
            $c06c31892548508b$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c06c31892548508b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c06c31892548508b$var$_defineProperty(e, r, t) {
    return (r = $c06c31892548508b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $c06c31892548508b$var$_toPropertyKey(t) {
    var i = $c06c31892548508b$var$_toPrimitive(t, "string");
    return "symbol" == $c06c31892548508b$var$_typeof(i) ? i : i + "";
}
function $c06c31892548508b$var$_toPrimitive(t, r) {
    if ("object" != $c06c31892548508b$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $c06c31892548508b$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $c06c31892548508b$var$Button = $c06c31892548508b$exports.Button = function Button(props) {
    var _props$id = props.id, id = _props$id === void 0 ? "" : _props$id, _props$className = props.className, className = _props$className === void 0 ? "" : _props$className, _props$colorStyle = props.colorStyle, colorStyle = _props$colorStyle === void 0 ? "primary" : _props$colorStyle, _props$type = props.type, type = _props$type === void 0 ? "button" : _props$type, _props$disabledToolti = props.disabledTooltipText, disabledTooltipText = _props$disabledToolti === void 0 ? "" : _props$disabledToolti, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableRipple = props.disableRipple, disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple, _props$disableFocusRi = props.disableFocusRipple, disableFocusRipple = _props$disableFocusRi === void 0 ? true : _props$disableFocusRi, _props$isLoading = props.isLoading, isLoading = _props$isLoading === void 0 ? false : _props$isLoading, _props$classes = props.classes, classes = _props$classes === void 0 ? null : _props$classes, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$fullWidthOnMob = props.fullWidthOnMobile, fullWidthOnMobile = _props$fullWidthOnMob === void 0 ? false : _props$fullWidthOnMob, _props$dataTestid = props["data-testid"], dataTestId = _props$dataTestid === void 0 ? null : _props$dataTestid, _props$dataCy = props["data-cy"], dataCy = _props$dataCy === void 0 ? null : _props$dataCy, onClick = props.onClick, _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size, _props$form = props.form, form = _props$form === void 0 ? null : _props$form;
    var isGhost = colorStyle === "ghost";
    var forceDisableAllRipple = isGhost || disabled;
    var componentId = id;
    var linkProps = {};
    var SingleButton = /*#__PURE__*/ (0, $84HHw$reactjsxruntime.jsx)($cac1573991102b6d$exports.Wrapper, {
        disabled: disabled,
        className: className,
        "data-testid": dataTestId,
        "data-cy": dataCy,
        fullWidth: fullWidth,
        fullWidthOnMobile: fullWidthOnMobile,
        children: /*#__PURE__*/ (0, $84HHw$reactjsxruntime.jsxs)($cac1573991102b6d$exports.StyledButton, $c06c31892548508b$var$_objectSpread($c06c31892548508b$var$_objectSpread({
            className: classes === null || classes === void 0 ? void 0 : classes.button,
            id: componentId,
            type: type,
            onClick: onClick,
            disabled: disabled,
            colorStyle: colorStyle,
            isLoading: isLoading,
            isGhost: isGhost,
            form: form,
            size: (0, $54a26cd9a2f0c50b$exports.getSize)(size, isGhost),
            disableRipple: forceDisableAllRipple || disableRipple,
            disableFocusRipple: forceDisableAllRipple || disableFocusRipple
        }, linkProps), {}, {
            children: [
                (0, $54a26cd9a2f0c50b$exports.renderLabel)(props),
                (0, $54a26cd9a2f0c50b$exports.renderIcon)(props)
            ]
        }), componentId)
    });
    if (disabled && disabledTooltipText) return /*#__PURE__*/ (0, $84HHw$reactjsxruntime.jsx)($ac782590520c5221$exports.ArrowToolTip, {
        title: disabledTooltipText,
        children: SingleButton
    });
    return SingleButton;
};




//# sourceMappingURL=index.js.map
